import {
  Button,
  Config,
  Dropdown,
  Flex,
  theme,
  Typography,
  type ComponentSizeType,
} from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

import { useComponentSizeStore } from '@/store/componentSizeStore';

const ComponentSizeToggle = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { componentSize, setComponentSize } = useComponentSizeStore();

  const menuItems = Object.values(Config.ComponentSize).map((s) => ({
    key: s as string,
    label: t(`size.${s}`),
  }));

  const handleMenuClick = ({ key }: { key: string }) => {
    setComponentSize(key as ComponentSizeType);
  };

  return (
    <Flex gap="8px" align="center" justify="center">
      <Typography.Text style={{ color: token.Layout?.headerColor }}>
        {t('size.title')}:
      </Typography.Text>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        placement="bottom">
        <Button>{t(`size.${componentSize}`)}</Button>
      </Dropdown>
    </Flex>
  );
};

export default ComponentSizeToggle;
